import { useState, useEffect } from "react";
import { useCart } from "./CartContext";
import CartItem from "./CartItem";
import { Link } from "react-router-dom";

export default function CartDrawer() {
  const isMobile = useIsMobile();
  const { cart, isDrawerOpen, setDrawerOpen } = useCart();
  const [ isClosing, setIsClosing ] = useState(false);

  useEffect(() => {
    if (isDrawerOpen && isMobile) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isDrawerOpen, isMobile]);

  if (!isDrawerOpen) return null;

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  const checkoutButton = cart.length > 0 && (
    <Link to="/customize" state={{ fromDrawer: true }}>
      <button className="wizard-button">
        {cart.length >= 2 ? 'Customize Cards →' : 'Customize Card →'}
      </button>
    </Link>
  );

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setDrawerOpen(false);
      setIsClosing(false);
    }, 300); // match animation duration
  };

  return (
    <div className="cart-underlay">
    <div className={`cart-drawer ${isClosing ? 'closing' : 'opening'}`}>

<div className="cart-scrollable-area">
        {/* Header */}
        <div className="cart-header">
          <button className="cart-close" onClick={handleClose}>✕</button>
          <div><h3>Your Cart Total: ${total.toFixed(2)}</h3></div>
          <div>Total items: {totalItems}</div>
        </div>
        
        {!isMobile && checkoutButton}
        
        {/* Summary */}
        <div className="cart-summary">
          <strong>Order Summary:</strong><br />
          {cart.map((item, index) => (
            <div key={index}>• {item.UITitle} (x{item.quantity})</div>
          ))}
        </div>

        {/* Items */}
        <div className="cart-scroll-container">
          {cart.length > 0 ? (
            cart.map((item) => <CartItem key={item.id} item={item} />)
          ) : (
            <div className="cart-empty-message"><h2>Your cart is empty.</h2></div>
          )}
        </div>
</div>
        {isMobile && (
          <div>
            {checkoutButton}
          </div>
        )}
      </div>
    </div>
  );
}



function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 600);
  
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return isMobile;
}